import React from "react";
import { css, useTheme, Theme } from "@emotion/react";

type Props = {
    isVisible: boolean,
    message?: string | null,
    children?: React.ReactNode,
    className?: string,
};

const ErrorMessage: React.FC<Props> = ({
    isVisible,
    message,
    children,
    className
}) => {

    const theme: Theme = useTheme();

    const style = css`
        display: flex;
        width: 100%;
        margin-top: 10px;
        background-color: ${theme.colours.red["50"]};
        border: 1px solid ${theme.colours.crimson};
        border-radius: ${theme.borderAndShadow.smallRadius};
        color: ${theme.colours.crimson};
        
        span {
            margin: 10px;
        }
    `;

    return (
        <>
            {isVisible && (
                <div id={"errorMessage"} css={style} className={className}>
                    <span>{message || children}</span>
                </div>
            )}
        </>
    );
};

export default ErrorMessage;
